// extracted by mini-css-extract-plugin
export var button = "_a-0";
export var buttonContent = "_a-e";
export var buttonGroup = "_a-c";
export var dontRestrainIconWidth = "_a-a";
export var dropdownButton = "_a-b";
export var iconContainer = "_a-9";
export var lg = "_a-4";
export var md = "_a-3";
export var pending = "_a-f";
export var sm = "_a-2";
export var spinner = "_a-d";
export var squared = "_a-8";
export var wrapText = "_a-g";
export var xl = "_a-5";
export var xs = "_a-1";
export var xxl = "_a-6";
export var xxxl = "_a-7";